const namespace = 'DUCKS/BOOKING';
export default namespace;
